// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageBlock_root__C1Y_x","imgWrap":"ImageBlock_imgWrap__Pw6YM","text":"ImageBlock_text__lkRFI"};